module.exports = __webpack_public_path__ + "static/wallpaper_design_award_2015_winner-790ea4b8451ff3d5485af27bb5160a32.png";